/* [DV-INDIRIM-SOZLESME v5 — 2026-08-27] Fiyat iddiasi kanit sozlesmesi.
   - Liste fiyati yalniz gosterimdir; yuzde veya gun iddiasi uretmez.
   - Kampanya indirimi yalniz marker v2 campaign kanitindan gelir.
   - Indirim oncesi 10/30 gun referansi yalniz marker v2 preCampaignReference'tir.
   - Son 3/7/14/30 gun iddiasi yalniz taze dv-rozet rollingLowest kanitidir.
   - Eksik kapsam/kaynak/hash, v1 marker veya sayisal basePrice FALLBACK DEGILDIR:
     iddia tamamen kapanir. */
(function () {
  'use strict';
  var BAYAT_MS = 48 * 60 * 60 * 1000;
  var TZ = 'Europe/Istanbul';
  var HASH_RE = /^[a-f0-9]{64}$/i;

  function stableValue(value) {
    if (Array.isArray(value)) return value.map(stableValue);
    if (!value || typeof value !== 'object') return value;
    var out = {};
    Object.keys(value).sort().forEach(function (key) {
      out[key] = stableValue(value[key]);
    });
    return out;
  }
  function evidenceBody(value) {
    var out = {};
    Object.keys(value || {}).forEach(function (key) {
      if (key !== 'evidenceHash') out[key] = value[key];
    });
    return out;
  }
  /* Senkron SHA-256 gerekir: fiyat karari render sirasinda verilir; WebCrypto
     Promise'i gelene kadar kanitsiz bir rozet gecici olarak dahi acilamaz. */
  function sha256(text) {
    var ascii;
    try { ascii = unescape(encodeURIComponent(String(text))); } catch (_) { return null; }
    var maxWord = Math.pow(2, 32);
    var words = [];
    var bitLength = ascii.length * 8;
    var hash = sha256.h = sha256.h || [];
    var k = sha256.k = sha256.k || [];
    var primeCounter = k.length;
    var isComposite = {};
    var candidate = 2;
    while (primeCounter < 64) {
      if (!isComposite[candidate]) {
        for (var multiple = candidate * candidate; multiple < 313; multiple += candidate) {
          isComposite[multiple] = true;
        }
        hash[primeCounter] = (Math.pow(candidate, 0.5) * maxWord) | 0;
        k[primeCounter++] = (Math.pow(candidate, 1 / 3) * maxWord) | 0;
      }
      candidate++;
    }
    ascii += '\x80';
    while (ascii.length % 64 - 56) ascii += '\x00';
    for (var i = 0; i < ascii.length; i++) {
      words[i >> 2] |= ascii.charCodeAt(i) << ((3 - i) % 4) * 8;
    }
    words[words.length] = (bitLength / maxWord) | 0;
    words[words.length] = bitLength;
    for (var block = 0; block < words.length;) {
      var chunk = words.slice(block, block += 16);
      var oldHash = hash.slice(0);
      for (i = 0; i < 64; i++) {
        var w15 = chunk[i - 15];
        var w2 = chunk[i - 2];
        var a = hash[0];
        var e = hash[4];
        var temp1 = hash[7] +
          ((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) +
          ((e & hash[5]) ^ ((~e) & hash[6])) + k[i] +
          (chunk[i] = i < 16 ? chunk[i] : (
            chunk[i - 16] +
            ((w15 >>> 7 | w15 << 25) ^ (w15 >>> 18 | w15 << 14) ^ (w15 >>> 3)) +
            chunk[i - 7] +
            ((w2 >>> 17 | w2 << 15) ^ (w2 >>> 19 | w2 << 13) ^ (w2 >>> 10))
          ) | 0);
        var temp2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^
          (a >>> 22 | a << 10)) +
          ((a & hash[1]) ^ (a & hash[2]) ^ (hash[1] & hash[2]));
        hash = [
          (temp1 + temp2) | 0,
          hash[0], hash[1], hash[2],
          (hash[3] + temp1) | 0,
          hash[4], hash[5], hash[6]
        ];
      }
      for (i = 0; i < 8; i++) hash[i] = (hash[i] + oldHash[i]) | 0;
    }
    var result = '';
    for (i = 0; i < 8; i++) {
      for (var j = 3; j + 1; j--) {
        var byte = hash[i] >> (j * 8) & 255;
        result += (byte < 16 ? '0' : '') + byte.toString(16);
      }
    }
    return result;
  }

  function tam(n) { var x = Number(n); return isFinite(x) ? Math.round(x) : 0; }
  function fiyatKurus(n) {
    var x = Number(n);
    return isFinite(x) && x > 0 ? Math.round(x * 100) : 0;
  }
  function yuzde(referansKurus, satisKurus) {
    if (!(referansKurus > 0) || !(satisKurus >= 0) || referansKurus <= satisKurus) return 0;
    return Math.round((referansKurus - satisKurus) * 100 / referansKurus);
  }
  function hashVar(v) {
    var expected = String(v && v.evidenceHash || '').toLowerCase();
    return !!v && HASH_RE.test(expected) &&
      sha256(JSON.stringify(stableValue(evidenceBody(v)))) === expected;
  }
  function gunSayisi(from, through) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(from || '')) ||
      !/^\d{4}-\d{2}-\d{2}$/.test(String(through || ''))) return 0;
    var left = Date.parse(String(from) + 'T00:00:00.000Z');
    var right = Date.parse(String(through) + 'T00:00:00.000Z');
    if (!isFinite(left) || !isFinite(right) || right < left) return 0;
    return Math.round((right - left) / 86400000) + 1;
  }
  function tamKapsam(v, izinliGunler) {
    var gun = Number(v && v.days);
    return !!v && izinliGunler.indexOf(gun) !== -1 &&
      Number(v.coverageDays) === gun && v.coverageComplete === true &&
      v.timezone === TZ && hashVar(v) &&
      /^\d{4}-\d{2}-\d{2}$/.test(String(v.coveredFrom || '')) &&
      /^\d{4}-\d{2}-\d{2}$/.test(String(v.coveredThrough || '')) &&
      gunSayisi(v.coveredFrom, v.coveredThrough) === gun;
  }

  function tazeVeri() {
    var d = window.__DV_ROZET__;
    if (!d || Number(d.v) !== 3 || !d.gen) return null;
    var yas = Date.now() - Date.parse(d.gen);
    if (!(yas >= 0) || yas > BAYAT_MS) return null;
    return d;
  }
  function kayit(vid) {
    var d = tazeVeri();
    if (!d || !d.varyant) return null;
    return d.varyant[String(vid)] || null;
  }
  function rollingLowest(vid, gosterilenKurus) {
    var row = kayit(vid);
    var root = row && row.priceEvidence;
    var proof = root && root.rollingLowest;
    if (!root || Number(root.schemaVersion) !== 1 ||
      root.source !== 'shopify-admin-price-history' ||
      root.timezone !== TZ || !hashVar(root) ||
      !tamKapsam(proof, [3, 7, 14, 30]) ||
      proof.kind !== 'rollingLowest' ||
      proof.source !== 'shopify-admin-price-history' ||
      !Array.isArray(proof.dayEvidenceHashes) ||
      proof.dayEvidenceHashes.length !== Number(proof.days) ||
      !proof.dayEvidenceHashes.every(function (hash) { return HASH_RE.test(String(hash)); })) return null;
    var kurus = fiyatKurus(proof.price);
    if (!(kurus > 0) || tam(gosterilenKurus) > kurus + 1) return null;
    return {
      tur: 'rollingLowest',
      gun: Number(proof.days),
      kurus: kurus,
      kaynak: proof.source,
      evidenceHash: String(proof.evidenceHash)
    };
  }

  function priceEvidence(ctx) {
    var marker = ctx && ctx.marker;
    var pe = marker && marker.priceEvidence;
    var startAt = marker && marker.startAt;
    var endAt = marker && marker.endAt;
    var now = Date.now();
    if (!marker || Number(marker.schemaVersion) !== 2 || !hashVar(marker) ||
      !pe || Number(pe.schemaVersion) !== 1 ||
      pe.timezone !== TZ || !hashVar(pe) || pe.rollingLowest !== null ||
      String(pe.source || '') !== String(marker.source || '') ||
      !startAt || !endAt || !isFinite(Date.parse(startAt)) ||
      !isFinite(Date.parse(endAt)) || Date.parse(startAt) >= Date.parse(endAt) ||
      now < Date.parse(startAt) || now >= Date.parse(endAt)) return null;
    var campaign = pe.campaign;
    var list = pe.listPrice;
    if (!campaign || !list || !hashVar(campaign) || !hashVar(list) ||
      campaign.kind !== 'campaign' || list.kind !== 'listPrice' ||
      campaign.source !== 'shopify-admin-campaign-readback' ||
      list.source !== 'shopify-admin-list-price-readback' ||
      campaign.timezone !== TZ || list.timezone !== TZ ||
      campaign.coverageComplete !== true || list.coverageComplete !== true ||
      campaign.claimEligible !== true || list.claimEligible !== false ||
      !isFinite(Date.parse(campaign.checkedAt || '')) ||
      !isFinite(Date.parse(list.checkedAt || '')) ||
      fiyatKurus(campaign.basePrice) !== fiyatKurus(marker.basePrice) ||
      fiyatKurus(campaign.salePrice) !== fiyatKurus(marker.salePrice) ||
      Number(campaign.percent) !== Number(marker.percent) ||
      fiyatKurus(list.price) !== fiyatKurus(marker.displayCompareAt) ||
      !(fiyatKurus(list.price) > fiyatKurus(marker.salePrice))) return null;
    return pe;
  }
  function campaignEvidence(ctx, gosterilenKurus) {
    var pe = priceEvidence(ctx);
    var proof = pe && pe.campaign;
    if (!proof || proof.kind !== 'campaign' ||
      proof.source !== 'shopify-admin-campaign-readback' ||
      proof.timezone !== TZ || proof.coverageComplete !== true ||
      proof.claimEligible !== true || !hashVar(proof)) return null;
    var base = fiyatKurus(proof.basePrice);
    var sale = fiyatKurus(proof.salePrice);
    var shown = tam(gosterilenKurus);
    var percent = Number(proof.percent);
    if (!(base > sale) || sale !== shown || !(percent > 0) || percent > 90 ||
      Math.abs(yuzde(base, sale) - percent) > 1) return null;
    return {
      tur: 'campaign',
      bazKurus: base,
      satisKurus: sale,
      yuzde: Math.round(percent),
      kaynak: proof.source,
      evidenceHash: String(proof.evidenceHash)
    };
  }
  function preCampaignReference(ctx, gosterilenKurus) {
    var pe = priceEvidence(ctx);
    var proof = pe && pe.preCampaignReference;
    if (!tamKapsam(proof, [10, 30]) ||
      proof.kind !== 'preCampaignReference' ||
      proof.source !== 'shopify-admin-price-history' ||
      !isFinite(Date.parse(proof.checkedAt || ''))) return null;
    var kurus = fiyatKurus(proof.price);
    if (!(kurus > tam(gosterilenKurus))) return null;
    return {
      tur: 'preCampaignReference',
      gun: Number(proof.days),
      kurus: kurus,
      kaynak: proof.source,
      evidenceHash: String(proof.evidenceHash)
    };
  }

  /* Eski imzaya sayisal dalga-oncesi degeri verilse bile asla kabul etmez. */
  function referansSec(ctx, gosterilenKurus) {
    if (!ctx || typeof ctx !== 'object') return null;
    return preCampaignReference(ctx, gosterilenKurus);
  }
  function minIddia(vid, gosterilenKurus) {
    return rollingLowest(vid, gosterilenKurus);
  }

  /* ctx: {vid,gosterilenKurus,varyantKurus,listeKurus,marker|priceEvidence,
           markerSchemaVersion,endAt,firsat,mod}. dalgaOncesiKurus bilincli olarak yoktur. */
  function hesapla(ctx) {
    ctx = ctx || {};
    var vid = String(ctx.vid || '');
    var gosterilen = tam(ctx.gosterilenKurus);
    var varyantFiyat = tam(ctx.varyantKurus);
    var liste = tam(ctx.listeKurus);
    var mod = String(ctx.mod || 'standart');
    if (!(gosterilen > 0)) return { gecerli: false, sebep: 'gosterilen-fiyat-yok' };
    if (mod === 'ozel-olcu' || mod === 'dinamik') return { gecerli: false, sebep: 'dinamik-fiyat' };
    if (varyantFiyat > 0 && gosterilen !== varyantFiyat) {
      return { gecerli: false, sebep: 'kesim-fiyat-ayrisiyor' };
    }

    var campaign = campaignEvidence(ctx, gosterilen);
    var reference = preCampaignReference(ctx, gosterilen);
    var rolling = rollingLowest(vid, gosterilen);
    if (!campaign && !reference && !rolling) {
      return { gecerli: false, sebep: 'dogrulanmis-fiyat-kaniti-yok' };
    }
    var source = campaign ? (ctx.firsat ? 'firsat' : 'urun') : null;
    var etiket = campaign
      ? ('%' + campaign.yuzde + (source === 'firsat' ? ' Fırsat indirimi' : ' İndirim'))
      : null;
    return {
      gecerli: true,
      kaynak: source,
      yuzde: campaign ? campaign.yuzde : 0,
      oranKaynagi: campaign ? campaign.kaynak : null,
      referansKurus: reference ? reference.kurus : null,
      listeKurus: liste,
      satisKurus: gosterilen,
      campaign: campaign,
      preCampaignReference: reference,
      preCampaignMetni: reference
        ? ('İndirimden önceki ' + reference.gun + ' günün en düşük fiyatı')
        : null,
      rollingLowest: rolling,
      rollingLowestMetni: rolling
        ? ('Son ' + rolling.gun + ' günün en düşük fiyatı')
        : null,
      // Geçiş uyumluluğu: tek satırlı eski tüketici rolling iddiayı görür;
      // iki kanıt hiçbir zaman birbiri yerine geçirilmez.
      min: rolling,
      minMetni: rolling ? ('Son ' + rolling.gun + ' günün en düşük fiyatı') : null,
      etiket: etiket
    };
  }

  window.DVIndirim = {
    surum: 5,
    hesapla: hesapla,
    minIddia: minIddia,
    rollingLowest: rollingLowest,
    preCampaignReference: preCampaignReference,
    campaignEvidence: campaignEvidence,
    referansSec: referansSec,
    yuzde: yuzde,
    tazeVeri: tazeVeri,
    BAYAT_MS: BAYAT_MS
  };
})();
